import type { CountryConfig } from './typing';

export const statements: CountryConfig = {
    enabled: true,
    createStatement: true,
    deliveryDefinitions: {
        distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
        format: ['PDF_A4', 'XML_SEPA', 'TXT_MT940'],
        periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
        canCreateDefinition: true,
        statementNumberEditable: true,
    },
    tableColumns: [
        { id: 'date', label: 'account.statements.statementDate', width: '80%' },
        { id: 'download', label: '', width: '20%' },
    ],
    showHelpCenterInfoBox: false,
};
